import Job from "../models/job";
import httpService from "./httpService";

const apiEndpoint = "/jobs";

const getJobs = () => {
  return httpService.get<Job[]>(`${apiEndpoint}/getJobs`);
};

const jobService = {
  getJobs,
};

export default jobService;
